module.exports = __webpack_public_path__ + "img/ddosProtection.ac3b5b2.svg";